import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerConditionClickableBoxDeleteButton from '../viewer/ViewerConditionClickableBoxDeleteButton';
import styled from 'foundations-theming/utils';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConditionLogicBoxContainer = styled.div.withConfig({
  displayName: "ConditionLogicBox__ConditionLogicBoxContainer",
  componentId: "sc-11uxa3v-0"
})(({
  theme
}) => ({
  '&&&': {
    alignItems: 'center',
    backgroundColor: theme.color['fill-tertiary-hover'],
    borderBottom: `1px solid ${theme.color['border-core-default']}`,
    borderRadius: `${theme.borderRadius[100]} ${theme.borderRadius[100]} 0 0`,
    display: 'flex',
    fontWeight: theme.typography['heading-200'].fontWeight,
    justifyContent: 'space-between',
    padding: `${theme.space[100]} ${theme.space[100]} ${theme.space[100]} ${theme.space[300]}`,
    textTransform: 'uppercase',
    '.delete-button-container': {
      display: 'block',
      padding: 0,
      position: 'static',
      width: '22px'
    }
  }
}));
const ConditionLogicBoxContentContainer = styled.div.withConfig({
  displayName: "ConditionLogicBox__ConditionLogicBoxContentContainer",
  componentId: "sc-11uxa3v-1"
})(["height:22px;"]);
const ConditionLogicBox = ({
  conditionPath,
  logicOperator
}) => {
  const {
    draftCondition,
    isInEditMode,
    viewerConditionToDelete,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  let logicBoxContent = null;
  if (logicOperator === LogicGroupNames.AND) {
    logicBoxContent = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.logicOperator.and"
    });
  } else if (logicOperator === LogicGroupNames.OR) {
    logicBoxContent = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.logicOperator.or"
    });
  }
  const isFilterBranchDeleteTriggered =
  // @ts-expect-error ts-migrate(2339) FIXME
  conditionPath && conditionPath.equals(viewerConditionToDelete);
  const isConditionOpenInEditor = Boolean(conditionPath && (draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath) && !(draftCondition !== null && draftCondition !== void 0 && draftCondition.isAddingNew) && conditionPath.equals(draftCondition.conditionPath));
  const showDeleteButtonForSinglePanel = conditionPath && isInEditMode && !isConditionOpenInEditor;
  const showDeleteButtonForTwoPanel = conditionPath && isInEditMode;
  const showDeleteButton = useOnePanel ? showDeleteButtonForSinglePanel : showDeleteButtonForTwoPanel;
  return /*#__PURE__*/_jsxs(ConditionLogicBoxContainer, {
    children: [/*#__PURE__*/_jsx(ConditionLogicBoxContentContainer, {
      children: logicBoxContent
    }), showDeleteButton &&
    /*#__PURE__*/
    // this is for AND groups
    _jsx(ViewerConditionClickableBoxDeleteButton, {
      conditionPath: conditionPath,
      isFilterBranchDeleteTriggered: isFilterBranchDeleteTriggered
    })]
  });
};
export default ConditionLogicBox;